import { deploy_boilerplate } from './deploy'

(function () {

    let str_html;
    let template_doc;

    const url_page_boilerplate_html = './pagepart_new.html';

    const isParseError = (parsedDocument) => {
        // parser and parsererrorNS could be cached on startup for efficiency
        var parser = new DOMParser(),
            errorneousParse = parser.parseFromString('<', 'text/xml'),
            parsererrorNS = errorneousParse.getElementsByTagName("parsererror")[0].namespaceURI;
    
        if (parsererrorNS === 'http://www.w3.org/1999/xhtml') {
            // In PhantomJS the parseerror element doesn't seem to have a special namespace, so we are just guessing here :(
            return parsedDocument.getElementsByTagName("parsererror").length > 0;
        }
    
        return parsedDocument.getElementsByTagNameNS(parsererrorNS, 'parsererror').length > 0;
    };
    
    
    fetch(url_page_boilerplate_html).then(
        (response) => {
            return response.text();
        }
    ).then(
        (response_text) => {
            const parser = new DOMParser();
            str_html = response_text;
            
            template_doc = parser.parseFromString(str_html, 'text/html');
            if(isParseError(template_doc)){
                return Promise.reject(new Error('boilerplate_error'));
            }
        }
    ).then(()=>{
        deploy_boilerplate(template_doc);
    }).catch((err)=>{
        throw err;
    });
})();
